import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GtrakAuthService } from '../../../../../app/features/authentication/services/gtrak-auth.service';
import { ToasterService } from "../../../../common/services/toaster.service";
@Component({
  selector: 'app-main-admin-page',
  templateUrl: 'main-admin.page.html',
  styleUrls: [
    './main-admin.page.scss',
  ]
})
export class MainAdminPage {
    constructor(
        private router: Router,
        private toasterService: ToasterService,
        private authService: GtrakAuthService,
      ) { 
      }

      navigateCost() {
        
        var id=this.authService.user;
        this.router.navigate(['admin-page/cost-center']);
      }
    navigateSettingAdmin() {
        this.router.navigate(['admin-page/setting-admin']);
      }
      navigateWO() {
        this.router.navigate(['admin-page/wo-approval']);
      }
     navigateSettingHandheld() {
        this.router.navigate(['admin-page/handheld-setting-admin']);
      }
       navigateRouteCommentAdmin() {
        this.router.navigate(['admin-page/route-comment-admin']);
      }
      navigateUploadImage(){
         this.router.navigate(['admin-page/image-upload']);
      }
       navigateWebProductAdmin(){
         this.router.navigate(['admin-page/web-product-admin']);
      }
      navigateUserAdmin(){
          this.router.navigate(['account-management']);
      }
      navigateWebEmblemsAdmin(){
              this.router.navigate(['admin-page/web-emblems-admin']);
      }
       navigateCustomerProduct() {
        
        this.router.navigate(['admin-page/web-customer-product']);
      }
      navigateWebOrderTypeAdmin(){
        this.router.navigate(['admin-page/web-order-type-admin']);
      }
      navigateWebOrder(){
        this.router.navigate(['admin-page/wo-approval']);
      }
     navigateCustomerSite(){
        this.router.navigate(['admin-page/customer-site-reports']);
      }
      navigateCustomAdmin(){
          this.router.navigate(['admin-page/custom-site-admin']);
      }
      
      dataNotAvailable(){
        this.toasterService.presentToast(
          "danger",
          `Data Not Available.`,
          "Error"
        );  
      }
}